<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper" v-if="hint">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !radioStatus }"
          @click="radioStatus = !radioStatus"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!radioStatus"
          :label="radioValue.value"
          @change="changeOptionCSS"
        >
          {{ radioValue.value }}
        </el-radio>
      </div>
      <el-checkbox v-model="radioStatus" class="control__checkbox" @change="changeOptionCSS" />
    </div>
    <div v-if="type === 'fadein-image-spin'" class="tips_loader">
      <span
        >Tip: disable switch fade with
        <a href="#" @click.prevent="handleOpenTab">Slider > Animation type</a>.</span
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import collapseParent from "@/store/observable/option-elements-parent";

export default {
  name: "RadioCSS",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: [Boolean, String],
    },
    type: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: Function,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.default,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false,
    };
  },
  computed: {
    ...mapState(["collapseOptions", "clearOptionsCSS"]),
    collapseParent,
  },
  watch: {
    clearOptionsCSS(val) {
      if (val) {
        this.radioStatus = false;
        this.value = this.default;
      }
    },
    eventClick(val) {
      this.value = this.default;
      this.radioStatus = val;
    },
    radioStatus(val) {
      this.changeOptionCSS();
    },
  },
  methods: {
    changeOptionCSS() {
      const value = this.radioStatus === true ? `${this.value}` : "";

      this.$emit("changeOptionCSS", {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
    },

    handleOpenTab() {
      this.collapseParent = "4";
      const element = document.querySelector(".el-collapse-item.is-active");

      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    },
  },
};
</script>

<style lang="scss">
.tips_loader {
  color: #6c7683;
  margin-left: 15px;

  a {
    color: rgb(50, 123, 192);
  }
}
</style>
